export default function RetroTopTabs({ tabs, activeTab, onChange, learningsCount }) {
  return (
    <div className="page-toolbar">
      <div className="page-tabs" role="tablist" aria-label="Retro tabs">
        {tabs.map((t) => (
          <button
            type="button"
            key={t.key}
            className={`page-tab${activeTab === t.key ? " page-tab--active" : ""}`}
            onClick={() => onChange?.(t.key)}
            role="tab"
            aria-selected={activeTab === t.key}
          >
            {t.label}
            {t.key === "learn" ? (
              <span className="page-tab-count">{learningsCount}</span>
            ) : null}
          </button>
        ))}
      </div>
    </div>
  );
}
